import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';


const config = {
    apiKey: process.env.REACT_APP_API_KEY, 
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
  };


  class Firebase {
    constructor() {
      app.initializeApp(config);

      this.auth = app.auth();
      this.auth.onAuthStateChanged((user) => {
        this.currentUser = user;
      }) 
      this.db = app.database();

      this.storage = app.storage();

      this.images = this.storage.ref('images')

      this.imageArray = []

    }

   getDownloadUrl = (image) =>
    this.images.child(image.name).getDownloadURL()
  
   getRefFromUrl = (url) =>
    this.storage.refFromURL(url);

   uploadImage = (image) =>
      this.storage.ref(`/images/${image.name}`).put(image)
    
   deleteImage = (image) => {
      let deleteRef = this.storage.ref(`/images/${image.name}`)
      deleteRef.delete().then(function() {  
        console.log('file deleted successfully')
      }).catch(function(error) {
        console.log('error')
      })
    }
 
   getAllImages = () => 
      this.images.listAll().then(function(res){
        return Promise.all(res.items.map(item =>
          item.getDownloadURL())
        )
    })


   getSearchHistory = (uid) => 
       this.db.ref(`users/${uid}`).once('value').then((snapshot) => snapshot.val()).then((userData) => {
        return userData && userData.search ? JSON.parse(userData.search) : [];
    })

    saveSearchHistory = (uid, currentSearchItems) => 
        this.db.ref(`users/${uid}/search`).set(JSON.stringify(currentSearchItems))

    getSavedImages = (uid) =>
        this.db.ref(`users/${uid}`).once('value').then((snapshot) => snapshot.val()).then((userData) => {
          return userData && userData.savedImages ? JSON.parse(userData.savedImages) : [];
    })

    saveImages = (uid, savedImages) => 
        this.db.ref(`users/${uid}/savedImages`).set( JSON.stringify(savedImages)) 
  
    doCreateUserWithEmailAndPassword = (email, password) =>
      this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
      this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = password => 
        this.auth.currentUser.updatePassword(password);

    user = uid => this.db.ref(`users/${uid}`);

    users = () => this.db.ref('users');

  }

  export default Firebase;